import * as React from 'react';
const Down = ({ ...props }) => (
    <svg
        width="12"
        height="14"
        viewBox="0 0 12 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            id="Vector"
            d="M-2.86827e-07 6.56183L5.34783 11.5L5.34783 2.33761e-07L6.67391 2.91726e-07L6.67391 11.5L12 6.56183L12 8.35725L6 14L-3.65307e-07 8.35725L-2.86827e-07 6.56183Z"
            fill="currentColor"
        />
    </svg>
);

export default Down;
